module.exports = __webpack_public_path__ + "img/14.dcb00c71.jpg";